"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonDefaultProps = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("./constants");
var _button = require("./styles/button");
var _ArrowRight = _interopRequireDefault(require("../Icons/ArrowRight"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Button = (0, _react.forwardRef)(({
  type = 'button',
  title,
  disabled = false,
  mode = _constants.TYPES.DEFAULT,
  variant = _constants.VARIANTS.SECONDARY,
  backgroundColorMode = _constants.BACKGROUND_COLOR_MODES.LIGHT,
  startIcon = null,
  endIcon = null,
  withLinkArrow,
  ...rest
}, ref) => {
  switch (mode) {
    case _constants.TYPES.INLINE:
      return _react.default.createElement(_button.InlineButton, (0, _extends2.default)({
        ref: ref,
        type: type,
        disabled: disabled,
        variant: variant,
        backgroundColorMode: backgroundColorMode,
        title: title,
        startIcon: startIcon,
        endIcon: endIcon
      }, rest), !!startIcon && _react.default.createElement(_button.ButtonIconWrapper, null, startIcon), !!title && _react.default.createElement(_button.ButtonTitle, null, title), !!endIcon && _react.default.createElement(_button.ButtonIconWrapper, null, endIcon));
    case _constants.TYPES.LINK:
      return _react.default.createElement(_button.LinkButton, (0, _extends2.default)({
        ref: ref,
        disabled: disabled,
        variant: variant,
        backgroundColorMode: backgroundColorMode
      }, rest), title, withLinkArrow && _react.default.createElement(_button.LinkButtonArrowWrapper, null, _react.default.createElement(_ArrowRight.default, {
        width: 16,
        height: 16
      })));
    case _constants.TYPES.DEFAULT:
    default:
      return _react.default.createElement(_button.FramedButton, (0, _extends2.default)({
        ref: ref,
        type: type,
        disabled: disabled,
        variant: variant,
        backgroundColorMode: backgroundColorMode,
        title: title,
        startIcon: startIcon,
        endIcon: endIcon
      }, rest), !!startIcon && _react.default.createElement(_button.ButtonIconWrapper, null, startIcon), !!title && _react.default.createElement(_button.ButtonTitle, null, title), !!endIcon && _react.default.createElement(_button.ButtonIconWrapper, null, endIcon));
  }
});
const ButtonDefaultProps = exports.ButtonDefaultProps = {
  type: 'button',
  disabled: false,
  mode: _constants.TYPES.DEFAULT,
  variant: _constants.VARIANTS.SECONDARY,
  backgroundColorMode: _constants.BACKGROUND_COLOR_MODES.LIGHT,
  startIcon: null,
  endIcon: null
};
var _default = exports.default = Button;